// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* styles.css */

body {
  /* background-image: url('../public/volleyball.png');
  background-size: 10%;
  background-repeat: repeat; */
  background-color: #f8f8f8;
    font-family: Arial, sans-serif;
    
  }
  
  nav {
    background-color: #b9a3bd;
    padding: 10px;
  }
  
  nav ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }
  
  nav ul li {
    display: inline-block;
    margin-right: 0px;
  }
  
  nav ul li a {
    color: #fff;
    text-decoration: none;
    padding: 5px 10px;
  }
  
  nav ul li a:hover {
    background-color: #555;
  }
  
  .container {
    max-width: 1030px; 
    margin: 20px auto;
    padding: 20px;
    border-radius: 5px;
    /* box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); */
  }

  .app-header{
    padding: 0px;
    position: flex;
    
  }

  .app-container{
    width:auto;
    height:auto;
    overflow:auto;
  }
  /* styles.css */

/* ...existing styles... */

table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}

table th,
table td {
  padding: 10px;
  text-align: left;
 
}

.card-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  grid-gap: 20px;
  padding: 10px;
}

.card {
  background-color: #d8ccdb;
  border-radius: 5px;
  padding: 15px;
  box-shadow: 0 2px 5px rgba(234, 233, 233, 0.1);
}
.card-container a:link{
  text-decoration: none
}

.tournament-card {
  background-color: #d9d3db;   /* Background color of the card */
  border: 1px solid #e1e1e1; /* Border style */
  border-radius: 15px; /* Rounded corners */
  padding: 10px; /* Spacing inside the card */
  margin: 10px; /* Spacing around the card */
  cursor: pointer; /* Change cursor to pointer on hover to indicate clickability */
  transition: transform 0.2s; /* Add a smooth transition on hover */
}

.tournament-card:hover {
  transform: scale(1.05); /* Enlarge the card slightly on hover */
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1); /* Add a subtle shadow on hover */
}



.select-button {
  display: block;
  padding: 10px 20px;
  background-color: #ddd;
  color: rgb(143, 28, 215);
  border-style: solid;
  border-width: 1px;
  border-color: black;
  border-radius: 10px;
  font-size: 16px;
  text-decoration: none;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin: 5px auto; /* Adjust the margin as needed */
  text-align: center; /* Center the button within the card */
}

.select-button:hover {
  background-color: rgba(231, 224, 224, 0.928);
}



.search-box-container {
  text-align: center;
  margin-bottom: 20px;
}

.search-box {
  width: 80%;
  max-width: 400px; /* Adjust the maximum width as needed */
  padding: 10px;
  border: 3px solid #d8ccdb; /* Border style */
  border-radius: 15px;
  background-color: #f2f2f2; /* Background color */
  color: #000; /* Text color */
  font-size: 16px;
  outline: none; /* Remove the default input focus style */
}

.search-box::placeholder {
  color: #777; /* Placeholder text color */
}


.form-label {
  padding-left: 10px;
}


.schedule-table {
  width: 100%;
  border-collapse: collapse;
}

.schedule-table th,
.schedule-table td {
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.schedule-table th {
  background-color: #f2f2f2;
}

.schedule-table th.sortable {
  cursor: pointer;
}

.schedule-table td:first-child {
  color: black;
}

.schedule-table td:nth-child(2) {
  color: black;
}

.schedule-table td:nth-child(3) {
  color: black;
}

.schedule-table td:nth-child(4) {
  color: blue;
}

.schedule-table td:nth-child(5) {
  color: black;
}


/* Burger Menu Styles */

.bm-burger-bars {
  background-color: blue;
  background: #373a47;
}


.bm-burger-button {
  position: fixed;
  width: 36px;
  height: 30px;
  left: 20px;
  top: 20px;
}

.bm-burger-bars-hover {
  background: #a90000;
}

.bm-cross-button {
  height: 24px;
  width: 24px;
}


.bm-cross {
  background: #bdc3c7;
}


.bm-menu {
  background: #bdc3c7;
  font-size: 1.15em;
}

.bm-menu-wrap {
  position: fixed;
  height: 100%;
  top: 0;
}

.bm-menu-wrap {
  background-color: lightgrey;
}


.bm-item-list {
  color: blue;
  padding: 0.8em;
}


.bm-item {
  display: inline-block;
  color: #e8e8e8;
  padding: 0.8em;
  text-decoration: none;
}


.bm-overlay {
  background: rgba(0, 0, 0, 0.3);
}

/* Mobile Menu Styles */
.mobile-menu {
  background: #b9a3bd;
  padding: 10px;
  padding-left: 0px;
  position: fixed;
  bottom: 0;
  left:0;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.mobile-menu a {
  color: #e8e8e8;
  text-decoration: none;
  padding: 8px;
  font-size: 14px;
  justify-content: center;
  text-align: center;
}



.mobile-menu .selected-menu-item {
  color: rgb(143, 28, 215);
}

.bm-menu-overlay {
  background: rgba(231, 224, 224, 0.928);
}

.bm-item-list a {
  color: black;
  text-decoration: none;
}

.bm-item-list a.selected-menu-item {
  color: rgb(143, 28, 215);

}



@media (min-width: 768px) {
  .bm-burger-button {
    display: none;
  }

  .app-main {
    margin-left: 0px;    
  }
  .app-main a:link{
    text-decoration: none
  }
}


.app-main {
  text-align: center;  
  padding: 15px;
  width: auto;
}

.app-footer {
  text-align: center;
  padding-bottom: 76px;
  padding-top: 0px;
}

.home{
  text-align: center;
}

.home-button{
  color: rgb(143, 28, 215);
  font-size: 16px;
  }

.app-footer a:link{
  text-decoration: none;
}

.home-button a:link{
  text-decoration: none;
  color: rgb(143, 28, 215);
font-size: 22px;
}

.home h3 {
  font-weight: normal;
}
.menu-button a:link{
  text-decoration: none;
  color: rgb(143, 28, 215);
  font-size: 22px;  
}

.bye-ref-row {
  background-color: #b9a3bd;
  font-weight: bold;
  color: black;
}

.bye-row {
  background-color: #d6c9d8;
  color: black;
  font-weight: bold;
  text-align: center;
}

.header-div {
  text-align: center;
  position: flex;
}

.menu-button{
  display: inline-block;
  padding: 10px 20px;
  background-color: #ddd;
  color: rgb(143, 28, 215);
  border: none;
  border-radius: 5px;  
  font-size: 16px;
  text-decoration: none;
  cursor: pointer;
  transition: background-color 0.3s ease;
  position: absolute;
  z-index: 2
  }
/* styles.css */

.header-button {
  display: inline-block;
  padding: 10px 20px;
  background-color: #ddd;
  color: rgb(143, 28, 215);
  border: none;
  border-radius: 5px;
  font-size: 16px;
  text-decoration: none;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.header-button:hover {
  background-color:  rgba(231, 224, 224, 0.928);;
}

@keyframes rainbow {
  0% { color: red; }
  14% { color: orange; }
  28% { color: yellow; }
  42% { color: green; }
  57% { color: blue; }
  71% { color: indigo; }
  85% { color: violet; }
  100% { color: red; }
}

.rainbow-text {
  font-size: 1.5rem;
  font-weight: bold;
  background: -webkit-linear-gradient(196deg, orange, blue, purple, indigo, violet);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: rainbow 8s linear infinite;
  line-height: 1; /* Adjust line-height */
  padding: 0.2em 0; /* Adjust padding */
  padding-top: 0px;
}

.h1{
padding-top: 0;
margin-top: 0;
}

.logo-image {
  width: 150px;
  height: 150px;
  /* Add any other styles for the image */
}


.header-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  position: relative;
}

.center-title {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  margin: 0;
  white-space: nowrap;
}

.user-icon {
  z-index: 1; /* Ensure it's on top if overlapping */
}

.spacer {
  width: 32px; /* or size of user icon, keeps left side from collapsing */
}


.desktop-header {
  align-items: center;
  position: flex;
}

.feedback-container {
  width: 80%;
  margin: 0 auto;
  padding: 20px;
}

.feedback-container h3 { font-weight: normal;}

.feedback-label {
  display: block;
  margin-bottom: 10px;
}

.feedback-list {
  margin-top: 20px;
}

.feedback-card {
  background-color:  #d8ccdb;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(234, 233, 233, 0.1);
}

.feedback-name {
  text-align: left;
  font-weight: bold ;
}

.feedback-text {
  margin-top: 5px;
  text-align: left;
  font-size:large;
}

/* UnderConstructionBanner.css */
.under-construction-banner {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #f8d7da; /* Red color as an example */
  color: #721c24; /* Dark color for text */
  padding: 10px;
  text-align: center;
}


.contact {
display:flex;
justify-content: center;
align-items: center;
min-height: auto;
}

.contact form{
  max-width: 600px;
  width: 100%;
  padding: 25px 25px 30px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgb(143, 28, 215);
  color: #333;
  margin: 25px;
}

.contact h2 {
  font-size: 25px;
  text-align: center;
}

.contact input-box {
  margin-top: 20px;
}

.contact .input-box .field {
  width: 90%;
  height: 30px;
  background: transparent;
  border: 2px solid #ddd;
  outline: none;
  border-radius: 6px;
  padding: 15px;
  font-size:  16px;
  color: #333;
  margin-top: 8px;
}

.contact .input-box .field.message{
  height: 200px;
  resize: none;
}

::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  white-space:pre-line;  
  position:relative;
  top:-7px;
  
}
::-moz-placeholder { /* Firefox 19+ */
     white-space:pre-line;  
  position:relative;
  top:-7px;
}
:-ms-input-placeholder { /* IE 10+ */
    white-space:pre-line;  
  position:relative;
  top:-7px;
}
:-moz-placeholder { /* Firefox 18- */
     white-space:pre-line;  
  position:relative;
  top:-7px;
}


.contact button{
  width: 80%;
  height: 55px;
  background:  #b9a3bd;
  border: none;
  border-radius: 6px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  font-size: 16px;
  color: #fff;
  font-weight: 500;
  margin-top: 25px;
}

.admin-actions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.5rem;
  margin-top: 2rem;
}

.admin-action-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1.2rem;
  background-color: #d9d3db;
  border-radius: 12px;
  text-decoration: none;
  color: #333;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease;
}

.admin-action-card:hover {
  transform: scale(1.05);
  background-color: #f1f1f1;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA,eAAe;;AAEf;EACE;;8BAE4B;EAC5B,yBAAyB;IACvB,8BAA8B;;EAEhC;;EAEA;IACE,yBAAyB;IACzB,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,8CAA8C;EAChD;;EAEA;IACE,YAAY;IACZ,cAAc;;EAEhB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,aAAa;EACf;EACA,eAAe;;AAEjB,0BAA0B;;AAE1B;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,gBAAgB;;AAElB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAc;EACd,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,8CAA8C;AAChD;AACA;EACE;AACF;;AAEA;EACE,yBAAyB,IAAI,iCAAiC;EAC9D,yBAAyB,EAAE,iBAAiB;EAC5C,mBAAmB,EAAE,oBAAoB;EACzC,aAAa,EAAE,4BAA4B;EAC3C,YAAY,EAAE,4BAA4B;EAC1C,eAAe,EAAE,+DAA+D;EAChF,0BAA0B,EAAE,qCAAqC;AACnE;;AAEA;EACE,sBAAsB,EAAE,uCAAuC;EAC/D,2CAA2C,EAAE,iCAAiC;AAChF;;;;AAIA;EACE,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,sCAAsC;EACtC,gBAAgB,EAAE,gCAAgC;EAClD,kBAAkB,EAAE,sCAAsC;AAC5D;;AAEA;EACE,4CAA4C;AAC9C;;;;AAIA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,gBAAgB,EAAE,uCAAuC;EACzD,aAAa;EACb,yBAAyB,EAAE,iBAAiB;EAC5C,mBAAmB;EACnB,yBAAyB,EAAE,qBAAqB;EAChD,WAAW,EAAE,eAAe;EAC5B,eAAe;EACf,aAAa,EAAE,yCAAyC;AAC1D;;AAEA;EACE,WAAW,EAAE,2BAA2B;AAC1C;;;AAGA;EACE,kBAAkB;AACpB;;;AAGA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;;AAGA,uBAAuB;;AAEvB;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;;AAGA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;;AAGA;EACE,mBAAmB;AACrB;;;AAGA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,MAAM;AACR;;AAEA;EACE,2BAA2B;AAC7B;;;AAGA;EACE,WAAW;EACX,cAAc;AAChB;;;AAGA;EACE,qBAAqB;EACrB,cAAc;EACd,cAAc;EACd,qBAAqB;AACvB;;;AAGA;EACE,8BAA8B;AAChC;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,SAAS;EACT,MAAM;EACN,WAAW;EACX,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,kBAAkB;AACpB;;;;AAIA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;;AAE1B;;;;AAIA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE;EACF;AACF;;;AAGA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf;;AAEF;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B,eAAe;AACf;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,sCAAsC;EACtC,kBAAkB;EAClB;EACA;AACF,eAAe;;AAEf;EACE,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,KAAK,UAAU,EAAE;EACjB,MAAM,aAAa,EAAE;EACrB,MAAM,aAAa,EAAE;EACrB,MAAM,YAAY,EAAE;EACpB,MAAM,WAAW,EAAE;EACnB,MAAM,aAAa,EAAE;EACrB,MAAM,aAAa,EAAE;EACrB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iFAAiF;EACjF,6BAA6B;EAC7B,oCAAoC;EACpC,qCAAqC;EACrC,cAAc,EAAE,uBAAuB;EACvC,gBAAgB,EAAE,mBAAmB;EACrC,gBAAgB;AAClB;;AAEA;AACA,cAAc;AACd,aAAa;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uCAAuC;AACzC;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,UAAU,EAAE,sCAAsC;AACpD;;AAEA;EACE,WAAW,EAAE,0DAA0D;AACzE;;;AAGA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,aAAa;AACf;;AAEA,yBAAyB,mBAAmB,CAAC;;AAE7C;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,yBAAyB,EAAE,4BAA4B;EACvD,cAAc,EAAE,wBAAwB;EACxC,aAAa;EACb,kBAAkB;AACpB;;;AAGA;AACA,YAAY;AACZ,uBAAuB;AACvB,mBAAmB;AACnB,gBAAgB;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,sCAAsC;EACtC,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA,8BAA8B,wBAAwB;EACpD,oBAAoB;EACpB,iBAAiB;EACjB,QAAQ;;AAEV;AACA,qBAAqB,gBAAgB;KAChC,oBAAoB;EACvB,iBAAiB;EACjB,QAAQ;AACV;AACA,yBAAyB,WAAW;IAChC,oBAAoB;EACtB,iBAAiB;EACjB,QAAQ;AACV;AACA,oBAAoB,gBAAgB;KAC/B,oBAAoB;EACvB,iBAAiB;EACjB,QAAQ;AACV;;;AAGA;EACE,UAAU;EACV,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,eAAe;EACf,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B","sourcesContent":["/* styles.css */\r\n\r\nbody {\r\n  /* background-image: url('../public/volleyball.png');\r\n  background-size: 10%;\r\n  background-repeat: repeat; */\r\n  background-color: #f8f8f8;\r\n    font-family: Arial, sans-serif;\r\n    \r\n  }\r\n  \r\n  nav {\r\n    background-color: #b9a3bd;\r\n    padding: 10px;\r\n  }\r\n  \r\n  nav ul {\r\n    list-style-type: none;\r\n    margin: 0;\r\n    padding: 0;\r\n  }\r\n  \r\n  nav ul li {\r\n    display: inline-block;\r\n    margin-right: 0px;\r\n  }\r\n  \r\n  nav ul li a {\r\n    color: #fff;\r\n    text-decoration: none;\r\n    padding: 5px 10px;\r\n  }\r\n  \r\n  nav ul li a:hover {\r\n    background-color: #555;\r\n  }\r\n  \r\n  .container {\r\n    max-width: 1030px; \r\n    margin: 20px auto;\r\n    padding: 20px;\r\n    border-radius: 5px;\r\n    /* box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); */\r\n  }\r\n\r\n  .app-header{\r\n    padding: 0px;\r\n    position: flex;\r\n    \r\n  }\r\n\r\n  .app-container{\r\n    width:auto;\r\n    height:auto;\r\n    overflow:auto;\r\n  }\r\n  /* styles.css */\r\n\r\n/* ...existing styles... */\r\n\r\ntable {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  margin-bottom: 20px;\r\n}\r\n\r\ntable th,\r\ntable td {\r\n  padding: 10px;\r\n  text-align: left;\r\n \r\n}\r\n\r\n.card-container {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\r\n  grid-gap: 20px;\r\n  padding: 10px;\r\n}\r\n\r\n.card {\r\n  background-color: #d8ccdb;\r\n  border-radius: 5px;\r\n  padding: 15px;\r\n  box-shadow: 0 2px 5px rgba(234, 233, 233, 0.1);\r\n}\r\n.card-container a:link{\r\n  text-decoration: none\r\n}\r\n\r\n.tournament-card {\r\n  background-color: #d9d3db;   /* Background color of the card */\r\n  border: 1px solid #e1e1e1; /* Border style */\r\n  border-radius: 15px; /* Rounded corners */\r\n  padding: 10px; /* Spacing inside the card */\r\n  margin: 10px; /* Spacing around the card */\r\n  cursor: pointer; /* Change cursor to pointer on hover to indicate clickability */\r\n  transition: transform 0.2s; /* Add a smooth transition on hover */\r\n}\r\n\r\n.tournament-card:hover {\r\n  transform: scale(1.05); /* Enlarge the card slightly on hover */\r\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1); /* Add a subtle shadow on hover */\r\n}\r\n\r\n\r\n\r\n.select-button {\r\n  display: block;\r\n  padding: 10px 20px;\r\n  background-color: #ddd;\r\n  color: rgb(143, 28, 215);\r\n  border-style: solid;\r\n  border-width: 1px;\r\n  border-color: black;\r\n  border-radius: 10px;\r\n  font-size: 16px;\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease;\r\n  margin: 5px auto; /* Adjust the margin as needed */\r\n  text-align: center; /* Center the button within the card */\r\n}\r\n\r\n.select-button:hover {\r\n  background-color: rgba(231, 224, 224, 0.928);\r\n}\r\n\r\n\r\n\r\n.search-box-container {\r\n  text-align: center;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.search-box {\r\n  width: 80%;\r\n  max-width: 400px; /* Adjust the maximum width as needed */\r\n  padding: 10px;\r\n  border: 3px solid #d8ccdb; /* Border style */\r\n  border-radius: 15px;\r\n  background-color: #f2f2f2; /* Background color */\r\n  color: #000; /* Text color */\r\n  font-size: 16px;\r\n  outline: none; /* Remove the default input focus style */\r\n}\r\n\r\n.search-box::placeholder {\r\n  color: #777; /* Placeholder text color */\r\n}\r\n\r\n\r\n.form-label {\r\n  padding-left: 10px;\r\n}\r\n\r\n\r\n.schedule-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n}\r\n\r\n.schedule-table th,\r\n.schedule-table td {\r\n  padding: 8px;\r\n  text-align: left;\r\n  border-bottom: 1px solid #ddd;\r\n}\r\n\r\n.schedule-table th {\r\n  background-color: #f2f2f2;\r\n}\r\n\r\n.schedule-table th.sortable {\r\n  cursor: pointer;\r\n}\r\n\r\n.schedule-table td:first-child {\r\n  color: black;\r\n}\r\n\r\n.schedule-table td:nth-child(2) {\r\n  color: black;\r\n}\r\n\r\n.schedule-table td:nth-child(3) {\r\n  color: black;\r\n}\r\n\r\n.schedule-table td:nth-child(4) {\r\n  color: blue;\r\n}\r\n\r\n.schedule-table td:nth-child(5) {\r\n  color: black;\r\n}\r\n\r\n\r\n/* Burger Menu Styles */\r\n\r\n.bm-burger-bars {\r\n  background-color: blue;\r\n  background: #373a47;\r\n}\r\n\r\n\r\n.bm-burger-button {\r\n  position: fixed;\r\n  width: 36px;\r\n  height: 30px;\r\n  left: 20px;\r\n  top: 20px;\r\n}\r\n\r\n.bm-burger-bars-hover {\r\n  background: #a90000;\r\n}\r\n\r\n.bm-cross-button {\r\n  height: 24px;\r\n  width: 24px;\r\n}\r\n\r\n\r\n.bm-cross {\r\n  background: #bdc3c7;\r\n}\r\n\r\n\r\n.bm-menu {\r\n  background: #bdc3c7;\r\n  font-size: 1.15em;\r\n}\r\n\r\n.bm-menu-wrap {\r\n  position: fixed;\r\n  height: 100%;\r\n  top: 0;\r\n}\r\n\r\n.bm-menu-wrap {\r\n  background-color: lightgrey;\r\n}\r\n\r\n\r\n.bm-item-list {\r\n  color: blue;\r\n  padding: 0.8em;\r\n}\r\n\r\n\r\n.bm-item {\r\n  display: inline-block;\r\n  color: #e8e8e8;\r\n  padding: 0.8em;\r\n  text-decoration: none;\r\n}\r\n\r\n\r\n.bm-overlay {\r\n  background: rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n/* Mobile Menu Styles */\r\n.mobile-menu {\r\n  background: #b9a3bd;\r\n  padding: 10px;\r\n  padding-left: 0px;\r\n  position: fixed;\r\n  bottom: 0;\r\n  left:0;\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: space-around;\r\n  align-items: center;\r\n}\r\n\r\n.mobile-menu a {\r\n  color: #e8e8e8;\r\n  text-decoration: none;\r\n  padding: 8px;\r\n  font-size: 14px;\r\n  justify-content: center;\r\n  text-align: center;\r\n}\r\n\r\n\r\n\r\n.mobile-menu .selected-menu-item {\r\n  color: rgb(143, 28, 215);\r\n}\r\n\r\n.bm-menu-overlay {\r\n  background: rgba(231, 224, 224, 0.928);\r\n}\r\n\r\n.bm-item-list a {\r\n  color: black;\r\n  text-decoration: none;\r\n}\r\n\r\n.bm-item-list a.selected-menu-item {\r\n  color: rgb(143, 28, 215);\r\n\r\n}\r\n\r\n\r\n\r\n@media (min-width: 768px) {\r\n  .bm-burger-button {\r\n    display: none;\r\n  }\r\n\r\n  .app-main {\r\n    margin-left: 0px;    \r\n  }\r\n  .app-main a:link{\r\n    text-decoration: none\r\n  }\r\n}\r\n\r\n\r\n.app-main {\r\n  text-align: center;  \r\n  padding: 15px;\r\n  width: auto;\r\n}\r\n\r\n.app-footer {\r\n  text-align: center;\r\n  padding-bottom: 76px;\r\n  padding-top: 0px;\r\n}\r\n\r\n.home{\r\n  text-align: center;\r\n}\r\n\r\n.home-button{\r\n  color: rgb(143, 28, 215);\r\n  font-size: 16px;\r\n  }\r\n\r\n.app-footer a:link{\r\n  text-decoration: none;\r\n}\r\n\r\n.home-button a:link{\r\n  text-decoration: none;\r\n  color: rgb(143, 28, 215);\r\nfont-size: 22px;\r\n}\r\n\r\n.home h3 {\r\n  font-weight: normal;\r\n}\r\n.menu-button a:link{\r\n  text-decoration: none;\r\n  color: rgb(143, 28, 215);\r\n  font-size: 22px;  \r\n}\r\n\r\n.bye-ref-row {\r\n  background-color: #b9a3bd;\r\n  font-weight: bold;\r\n  color: black;\r\n}\r\n\r\n.bye-row {\r\n  background-color: #d6c9d8;\r\n  color: black;\r\n  font-weight: bold;\r\n  text-align: center;\r\n}\r\n\r\n.header-div {\r\n  text-align: center;\r\n  position: flex;\r\n}\r\n\r\n.menu-button{\r\n  display: inline-block;\r\n  padding: 10px 20px;\r\n  background-color: #ddd;\r\n  color: rgb(143, 28, 215);\r\n  border: none;\r\n  border-radius: 5px;  \r\n  font-size: 16px;\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease;\r\n  position: absolute;\r\n  z-index: 2\r\n  }\r\n/* styles.css */\r\n\r\n.header-button {\r\n  display: inline-block;\r\n  padding: 10px 20px;\r\n  background-color: #ddd;\r\n  color: rgb(143, 28, 215);\r\n  border: none;\r\n  border-radius: 5px;\r\n  font-size: 16px;\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease;\r\n}\r\n\r\n.header-button:hover {\r\n  background-color:  rgba(231, 224, 224, 0.928);;\r\n}\r\n\r\n@keyframes rainbow {\r\n  0% { color: red; }\r\n  14% { color: orange; }\r\n  28% { color: yellow; }\r\n  42% { color: green; }\r\n  57% { color: blue; }\r\n  71% { color: indigo; }\r\n  85% { color: violet; }\r\n  100% { color: red; }\r\n}\r\n\r\n.rainbow-text {\r\n  font-size: 1.5rem;\r\n  font-weight: bold;\r\n  background: -webkit-linear-gradient(196deg, orange, blue, purple, indigo, violet);\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  animation: rainbow 8s linear infinite;\r\n  line-height: 1; /* Adjust line-height */\r\n  padding: 0.2em 0; /* Adjust padding */\r\n  padding-top: 0px;\r\n}\r\n\r\n.h1{\r\npadding-top: 0;\r\nmargin-top: 0;\r\n}\r\n\r\n.logo-image {\r\n  width: 150px;\r\n  height: 150px;\r\n  /* Add any other styles for the image */\r\n}\r\n\r\n\r\n.header-container {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 10px 20px;\r\n  position: relative;\r\n}\r\n\r\n.center-title {\r\n  position: absolute;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  margin: 0;\r\n  white-space: nowrap;\r\n}\r\n\r\n.user-icon {\r\n  z-index: 1; /* Ensure it's on top if overlapping */\r\n}\r\n\r\n.spacer {\r\n  width: 32px; /* or size of user icon, keeps left side from collapsing */\r\n}\r\n\r\n\r\n.desktop-header {\r\n  align-items: center;\r\n  position: flex;\r\n}\r\n\r\n.feedback-container {\r\n  width: 80%;\r\n  margin: 0 auto;\r\n  padding: 20px;\r\n}\r\n\r\n.feedback-container h3 { font-weight: normal;}\r\n\r\n.feedback-label {\r\n  display: block;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.feedback-list {\r\n  margin-top: 20px;\r\n}\r\n\r\n.feedback-card {\r\n  background-color:  #d8ccdb;\r\n  padding: 10px;\r\n  margin-bottom: 10px;\r\n  border-radius: 5px;\r\n  box-shadow: 0 2px 5px rgba(234, 233, 233, 0.1);\r\n}\r\n\r\n.feedback-name {\r\n  text-align: left;\r\n  font-weight: bold ;\r\n}\r\n\r\n.feedback-text {\r\n  margin-top: 5px;\r\n  text-align: left;\r\n  font-size:large;\r\n}\r\n\r\n/* UnderConstructionBanner.css */\r\n.under-construction-banner {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  background-color: #f8d7da; /* Red color as an example */\r\n  color: #721c24; /* Dark color for text */\r\n  padding: 10px;\r\n  text-align: center;\r\n}\r\n\r\n\r\n.contact {\r\ndisplay:flex;\r\njustify-content: center;\r\nalign-items: center;\r\nmin-height: auto;\r\n}\r\n\r\n.contact form{\r\n  max-width: 600px;\r\n  width: 100%;\r\n  padding: 25px 25px 30px;\r\n  border-radius: 8px;\r\n  box-shadow: 0 0 10px rgb(143, 28, 215);\r\n  color: #333;\r\n  margin: 25px;\r\n}\r\n\r\n.contact h2 {\r\n  font-size: 25px;\r\n  text-align: center;\r\n}\r\n\r\n.contact input-box {\r\n  margin-top: 20px;\r\n}\r\n\r\n.contact .input-box .field {\r\n  width: 90%;\r\n  height: 30px;\r\n  background: transparent;\r\n  border: 2px solid #ddd;\r\n  outline: none;\r\n  border-radius: 6px;\r\n  padding: 15px;\r\n  font-size:  16px;\r\n  color: #333;\r\n  margin-top: 8px;\r\n}\r\n\r\n.contact .input-box .field.message{\r\n  height: 200px;\r\n  resize: none;\r\n}\r\n\r\n::-webkit-input-placeholder { /* Chrome/Opera/Safari */\r\n  white-space:pre-line;  \r\n  position:relative;\r\n  top:-7px;\r\n  \r\n}\r\n::-moz-placeholder { /* Firefox 19+ */\r\n     white-space:pre-line;  \r\n  position:relative;\r\n  top:-7px;\r\n}\r\n:-ms-input-placeholder { /* IE 10+ */\r\n    white-space:pre-line;  \r\n  position:relative;\r\n  top:-7px;\r\n}\r\n:-moz-placeholder { /* Firefox 18- */\r\n     white-space:pre-line;  \r\n  position:relative;\r\n  top:-7px;\r\n}\r\n\r\n\r\n.contact button{\r\n  width: 80%;\r\n  height: 55px;\r\n  background:  #b9a3bd;\r\n  border: none;\r\n  border-radius: 6px;\r\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\r\n  cursor: pointer;\r\n  font-size: 16px;\r\n  color: #fff;\r\n  font-weight: 500;\r\n  margin-top: 25px;\r\n}\r\n\r\n.admin-actions-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\r\n  gap: 1.5rem;\r\n  margin-top: 2rem;\r\n}\r\n\r\n.admin-action-card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  padding: 1.2rem;\r\n  background-color: #d9d3db;\r\n  border-radius: 12px;\r\n  text-decoration: none;\r\n  color: #333;\r\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\r\n  transition: transform 0.2s ease;\r\n}\r\n\r\n.admin-action-card:hover {\r\n  transform: scale(1.05);\r\n  background-color: #f1f1f1;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
